export default __webpack_public_path__ + "static/media/2h.44a7916c.jpg";